module.exports = __webpack_public_path__ + "img/placemakers-underconstruction-main.14b7c0b1.jpg";